import script from "./FilterPayments.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterPayments.vue?vue&type=script&lang=ts&setup=true"

export default script